import "../css/SideNavbar.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

function SideNavBarHR(props) {
    const navigate = useNavigate();
    const [showMenu, setShowMenu] = useState("");
    const [showSubMenu, setShowSubMenu] = useState("");

    useEffect(() => {
        setShowMenu(props.activeMenu)
    }, [props.activeMenu]);

    useEffect(() => {
        setShowSubMenu(props.activeSubMenu)
    }, [props.activeSubMenu]);

    return (
        <>
            <a onClick={() => setShowMenu(showMenu=="HR"?"":"HR")} title="HR" className={props.activeMenu == "HR" ? "sidenav-expanded-active pointer px-0 sidenavbar-text" : "pointer px-0 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("hr:hr:view")?false:true}>
                <i className="fa fa-users sidenavbar-icon px-3"></i>
                <span className="mx-3 sidenavbar-text">HR
                    <i className={showMenu=="HR"?"fa fa-angle-up fa-lg mx-3 float-right":"fa fa-angle-down fa-lg mx-3 float-right"}></i>
                </span>
            </a>
            <ul className={showMenu == "HR" ? "multilevel-sidenav mt-1": "display-none"}>
                <a onClick={() => navigate("/hr/employee")} title="Employees"
                className={props.activeSubMenu == "EmployeeList" ? "sidenav-expanded-active pointer px-1 sidenavbar-text" : "pointer px-1 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("hr:employee:view")?false:true}>
                    <span className="mx-3">Employees</span>
                </a>
            </ul>
            <ul className={showMenu == "HR" ? "multilevel-sidenav mt-1": "display-none"}>
                <a onClick={() => navigate("/hr/attendanceleave")} title="Attendance & Leave"
                className={props.activeSubMenu == "AttendanceLeave" ? "sidenav-expanded-active pointer px-1 sidenavbar-text" : "pointer px-1 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("hr:attendance:view")?false:true}>
                    <span className="mx-3">Attendance &amp; Leave</span>
                </a>
            </ul>
            <ul className={showMenu == "HR" ? "multilevel-sidenav mt-1": "display-none"}>
                <a onClick={() => navigate("/hr/payroll")} title="Payroll"
                className={props.activeSubMenu == "PayrollManagement" ? "sidenav-expanded-active pointer px-1 sidenavbar-text" : "pointer px-1 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("hr:payroll:view")?false:true}>
                    <span className="mx-3">Payroll</span>
                </a>
            </ul>
            <ul className={showMenu == "HR" ? "multilevel-sidenav mt-1": "display-none"}>
                <a onClick={() => navigate("/hr/asset")} title="Asset Management"
                className={props.activeSubMenu == "AssetManagement" ? "sidenav-expanded-active pointer px-1 sidenavbar-text" : "pointer px-1 sidenavbar-text"}
                hidden={props.currentUserRolePermissionData?.includes("hr:asset:view")?false:true}>
                    <span className="mx-3">Asset Management</span>
                </a>
            </ul>
        </>
    );
}

export default SideNavBarHR;
